import z from 'zod';

const hcpForm = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  email: z
    .string()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Invalid email address' }),
  specialty: z.string().min(1, {
    message: 'Provider Type/Specialty/Area of Interest is required',
  }),
  npi: z.string().min(1, { message: 'NPI Number is required' }),
  zip: z
    .string()
    .optional()
    .or(z.literal(''))
    .refine((val) => !val || val.length >= 5, {
      message: 'ZIP code must be at least 5 characters',
    }),
  institution: z.string().optional().or(z.literal('')),
  phone: z
    .string()
    .optional()
    .or(z.literal(''))
    .refine(
      (val) => !val || /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(val),
      { message: 'Invalid phone number format' },
    ),
  hubspotInfo: z.literal<boolean>(true, {
    error: () => ({ message: 'You must agree to be contacted' }),
  }),
  shareInfo: z.literal<boolean>(true, {
    error: () => ({ message: 'You must agree to the privacy policy' }),
  }),
});

export { hcpForm };
